import { Link } from "react-router-dom";
import { IMAGES, NAV, CONTACT } from "@/lib/site-data";

export const Footer = () => (
  <footer data-testid="site-footer" className="bg-[#14171a] border-t border-white/10">
    <div className="max-w-7xl mx-auto px-5 sm:px-8 py-16 grid gap-12 md:grid-cols-3">
      <div>
        <img data-testid="footer-logo" src={IMAGES.logo} alt="Ringel Fenstertechnik" className="h-24 w-auto mb-6" />
        <p className="text-white/50 text-sm leading-relaxed max-w-xs">
          Fenster, Türen und Bauelemente in Meisterqualität – beraten, geliefert und montiert aus einer Hand.
        </p>
      </div>
      <div>
        <h4 className="font-display text-white font-semibold text-sm uppercase tracking-[0.22em] mb-6">Navigation</h4>
        <nav className="flex flex-col gap-3">
          {NAV.map((n) => (
            <a key={n.href} data-testid={`footer-nav-${n.label.toLowerCase().replace(/[^a-z]/g, "-")}`} href={n.href} className="text-white/55 hover:text-white text-sm transition-colors duration-200 w-fit">
              {n.label}
            </a>
          ))}
        </nav>
      </div>
      <div>
        <h4 className="font-display text-white font-semibold text-sm uppercase tracking-[0.22em] mb-6">Kontakt</h4>
        <div className="flex flex-col gap-3 text-sm text-white/55">
          <span>{CONTACT.address}</span>
          <a data-testid="footer-phone" href={`tel:${CONTACT.phoneRaw}`} className="hover:text-white transition-colors duration-200 w-fit">{CONTACT.phone}</a>
          <a data-testid="footer-email" href={`mailto:${CONTACT.email}`} className="hover:text-white transition-colors duration-200 w-fit">{CONTACT.email}</a>
        </div>
      </div>
    </div>
    <div className="border-t border-white/10">
      <div className="max-w-7xl mx-auto px-5 sm:px-8 py-6 flex flex-wrap items-center justify-between gap-4 text-xs text-white/40">
        <span>© {new Date().getFullYear()} Ringel Fenstertechnik. Alle Rechte vorbehalten.</span>
        <div className="flex gap-6">
          <Link data-testid="footer-impressum" to="/impressum" className="hover:text-white transition-colors duration-200">Impressum</Link>
          <Link data-testid="footer-datenschutz" to="/datenschutz" className="hover:text-white transition-colors duration-200">Datenschutz</Link>
          <Link data-testid="footer-admin" to="/admin" className="hover:text-white transition-colors duration-200">Admin</Link>
        </div>
      </div>
    </div>
  </footer>
);
